import React from "react";
import { Box, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { DARCKCOLOR } from "../../helpers/Config";
import { sxRowCenterBetween, sxText1440020 } from "../../theme/sxStyle";

const sxButton = {
  ...sxText1440020,
  height: "56px",
  borderRadius: "45px",
  border: "1px solid rgba(33, 37, 41, 0.2)",
  "&:hover": {
    backgroundColor: "rgba(33, 37, 41, 1)",
    color: "#fff",
  },
};

const FooterButtons = () => {
  const location = useLocation();

  const getButtonStyles = (path) => ({
    ...sxButton,
    backgroundColor: location.pathname === path ? "rgba(33, 37, 41, 1)" : "#fff",
    color: location.pathname === path ? "#fff" : DARCKCOLOR,
  });

  return (
    <Box
      position="fixed"
      bottom="40px"
      left="50%"
      zIndex={5}
      gap={1}
      width="100%"
      maxWidth="400px"
      p="0 16px"
      sx={{
        ...sxRowCenterBetween,
        transform: "translate(-50%, 0)",
        "@media (min-width: 768px)": {
          maxWidth: "600px",
          gap: 3,
        },
      }}
    >
      <Button
        variant="contained"
        color="primary"
        fullWidth
        component={Link}
        to="/travel"
        sx={getButtonStyles("/travel")}
      >
        Explore
      </Button>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        component={Link}
        to="/travel/guides"
        sx={getButtonStyles("/travel/guides")}
      >
        Bookings
      </Button>
    </Box>
  );
};

export default FooterButtons;